import { useGlobalStoreSelector } from '@/stores/global.store';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export const useFormatDateTime = () => {
	const currentLanguage = useGlobalStoreSelector((s) => s.language);

	const formatDateTime = (date: Date, options?: Intl.DateTimeFormatOptions) => {
		return new Intl.DateTimeFormat(currentLanguage === 'en' ? 'en-US' : currentLanguage, options).format(date);
	};

	return formatDateTime;
};
